module.exports = __webpack_public_path__ + "459bb70e89b65f4ac2234b5f8dda2117.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/TrainingGroups/training-groups1.jpg
// module id = 1231
// module chunks = 0